// @flow

import * as types from '../actionTypes';
import genericReducer, { genericSelectorSet, useGeneric } from './generic';
import { saleSchema } from '../schemata';
import type { transactionSchemaType } from '../../types';

const saleSchemaReducer = genericReducer(types.GET_SALESCHEMA_ASYNC);

export default saleSchemaReducer;

export const selectSaleSchema = genericSelectorSet<transactionSchemaType>(
  saleSchema,
  state => state.saleSchema,
);

export const useSaleSchema = useGeneric<transactionSchemaType>(
  saleSchema,
  state => state.saleSchema,
);
